// TODO: access locale data when available
const LOCALE = "en-US"
const CURRENCY = "USD"

const formatters = {
  wholeCurrency: new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: CURRENCY,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }),
  decimalCurrency: new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: CURRENCY,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
  wholeNumber: new Intl.NumberFormat(LOCALE, {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }),
  decimalNumber: new Intl.NumberFormat(LOCALE, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }),
}

interface FormatCentsOptions {
  noCentsIfWhole?: boolean
}

function formatCents(
  cents: number,
  wholeFormatter: Intl.NumberFormat,
  decimalFormatter: Intl.NumberFormat,
  options: FormatCentsOptions = {},
) {
  const { noCentsIfWhole = true } = options
  const dollars = cents / 100
  const isWholeDollar = cents % 100 === 0

  return isWholeDollar && noCentsIfWhole
    ? wholeFormatter.format(dollars)
    : decimalFormatter.format(dollars)
}

export function formattedCents(cents: number, options?: FormatCentsOptions) {
  return formatCents(
    cents,
    formatters.wholeCurrency,
    formatters.decimalCurrency,
    options,
  )
}

export function formattedCentsNumber(
  cents: number,
  options?: FormatCentsOptions,
) {
  return formatCents(
    cents,
    formatters.wholeNumber,
    formatters.decimalNumber,
    options,
  )
}

export function moneyInputSanitize(numberIn: string): string {
  let number = numberIn

  number = `${number}`
  // eslint-disable-next-line prefer-const
  let [dollars, cents] = number
    .toString()
    .replace(/[^\d.]/g, "")
    .split(".")

  if (/^0+$/.test(dollars)) {
    dollars = "0"
  } else if (dollars.length > 1) {
    // Trim extra leading zeros ('02' becomes '2')
    dollars = dollars.replace(/^0+/, "")
  } else if (dollars.length === 0 && typeof cents !== "undefined") {
    // Add leading zero when cents are present ('.' becomes '0.')
    dollars = "0"
  }

  if (typeof cents === "undefined") {
    // There was no '.'
    return dollars
  } else {
    // '.' was anywhere
    return [dollars, cents.slice(0, 2)].join(".")
  }
}
